<script>
import { proivderLocation } from "./data";
export default {
  data() {
    return {
      proivderLocation: proivderLocation,
    };
  },
};
</script>
<template>
  <div class="col-xxl-4 col-md-6 d-flex">
    <div class="card flex-fill">
      <div class="card-body">
        <h6 class="mb-4">Top Locations</h6>
        <div id="deals-chart">
          <apexchart
            type="bar"
            height="260"
            :options="proivderLocation.location"
            :series="proivderLocation.series"
          >
          </apexchart>
        </div>
        <div>
          <p>Top Locations & Users</p>
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="d-flex">
              <span class="avatar avatar-lg me-2">
                <img
                  src="@/assets/img/icons/flag-01.svg"
                  class="rounded-circle"
                  alt="flag"
                />
              </span>
              <div>
                <p class="text-dark fw-medium mb-0">Saudi Arabia</p>
                <span class="fs-12">California</span>
              </div>
            </div>
            <span class="badge badge-info">
              <i class="ti ti-point-filled"></i>
              300 Bookings
            </span>
          </div>
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="d-flex">
              <span class="avatar avatar-lg me-2">
                <img
                  src="@/assets/img/icons/flag-02.svg"
                  class="rounded-circle"
                  alt="flag"
                />
              </span>
              <div>
                <p class="text-dark fw-medium mb-0">Honkong</p>
                <span class="fs-12">California</span>
              </div>
            </div>
            <span class="badge badge-info">
              <i class="ti ti-point-filled"></i>
              300 Bookings
            </span>
          </div>
          <div class="d-flex justify-content-between align-items-center mb-0">
            <div class="d-flex">
              <span class="avatar avatar-lg me-2">
                <img
                  src="@/assets/img/icons/flag-03.svg"
                  class="rounded-circle"
                  alt="flag"
                />
              </span>
              <div>
                <p class="text-dark fw-medium mb-0">Germany</p>
                <span class="fs-12">California</span>
              </div>
            </div>
            <span class="badge badge-info">
              <i class="ti ti-point-filled"></i>
              300 Bookings
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-6 d-flex">
    <div class="card flex-fill">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h6>Latest Reviews</h6>
          <router-link to="/provider/provider-reviews" class="btn border">View All</router-link>
        </div>
        <div class="border-bottom pb-3 mb-3">
          <div
            class="d-flex justify-content-between align-items-center flex-wrap row-gap-2"
          >
            <div class="d-flex">
              <a href="javascript:void(0);" class="avatar avatar-lg flex-shrink-0 me-2">
                <img
                  src="@/assets/img/profiles/avatar-01.jpg"
                  class="rounded-circle"
                  alt="Img"
                />
              </a>
              <div>
                <router-link to="/provider/provider-reviews" class="fw-medium"
                  >Maude Rossi</router-link
                >
                <div class="d-flex align-items-center">
                  <p class="fs-12 mb-0 pe-2 border-end">
                    For <span class="text-info">Plumbing installation</span>
                  </p>
                  <span class="avatar avatar-sm mx-2">
                    <img
                      src="@/assets/img/user/user-03.jpg"
                      class="img-fluid rounded-circle"
                      alt="user"
                    />
                  </span>
                  <span class="fs-12">rebecca</span>
                </div>
              </div>
            </div>
            <div class="d-flex">
              <span class="text-warning fs-10">
                <i class="ti ti-star-filled filled"></i>
                <i class="ti ti-star-filled filled"></i>
                <i class="ti ti-star-filled filled"></i>
                <i class="ti ti-star-filled filled"></i>
                <i class="ti ti-star-filled filled"></i>
              </span>
              <span class="fs-12">4.9</span>
            </div>
          </div>
        </div>
        <div class="border-bottom pb-3 mb-3">
          <div
            class="d-flex justify-content-between align-items-center flex-wrap row-gap-2"
          >
            <div class="d-flex">
              <a href="javascript:void(0);" class="avatar avatar-lg flex-shrink-0 me-2">
                <img
                  src="@/assets/img/profiles/avatar-02.jpg"
                  class="rounded-circle"
                  alt="Img"
                />
              </a>
              <div>
                <router-link to="/provider/provider-reviews" class="fw-medium"
                  >Livengood</router-link
                >
                <div class="d-flex align-items-center">
                  <p class="fs-12 mb-0 pe-2 border-end">
                    For <span class="text-info"> Plumbing Repairs</span>
                  </p>
                  <span class="avatar avatar-sm mx-2">
                    <img
                      src="@/assets/img/user/user-04.jpg"
                      class="img-fluid rounded-circle"
                      alt="user"
                    />
                  </span>
                  <span class="fs-12">Adrian</span>
                </div>
              </div>
            </div>
            <div class="d-flex">
              <span class="text-warning fs-10">
                <i class="ti ti-star-filled filled"></i>
                <i class="ti ti-star-filled filled"></i>
                <i class="ti ti-star-filled filled"></i>
                <i class="ti ti-star-filled filled"></i>
                <i class="ti ti-star-filled filled"></i>
              </span>
              <span class="fs-12">4.9</span>
            </div>
          </div>
        </div>
        <div class="border-bottom pb-3 mb-3">
          <div
            class="d-flex justify-content-between align-items-center flex-wrap row-gap-2"
          >
            <div class="d-flex">
              <a href="javascript:void(0);" class="avatar avatar-lg flex-shrink-0 me-2">
                <img
                  src="@/assets/img/profiles/avatar-03.jpg"
                  class="rounded-circle"
                  alt="Img"
                />
              </a>
              <div>
                <router-link to="/provider/provider-reviews" class="fw-medium"
                  >Karl Brown</router-link
                >
                <div class="d-flex align-items-center">
                  <p class="fs-12 mb-0 pe-2 border-end">
                    For <span class="text-info"> Construction Worker</span>
                  </p>
                  <span class="avatar avatar-sm mx-2">
                    <img
                      src="@/assets/img/user/user-05.jpg"
                      class="img-fluid rounded-circle"
                      alt="user"
                    />
                  </span>
                  <span class="fs-12">Andreson </span>
                </div>
              </div>
            </div>
            <div class="d-flex">
              <span class="text-warning fs-10">
                <i class="ti ti-star-filled filled"></i>
                <i class="ti ti-star-filled filled"></i>
                <i class="ti ti-star-filled filled"></i>
                <i class="ti ti-star-filled filled"></i>
                <i class="ti ti-star-filled filled"></i>
              </span>
              <span class="fs-12">4.9</span>
            </div>
          </div>
        </div>
        <div class="border-bottom pb-3 mb-3">
          <div
            class="d-flex justify-content-between align-items-center flex-wrap row-gap-2"
          >
            <div class="d-flex">
              <a href="javascript:void(0);" class="avatar avatar-lg flex-shrink-0 me-2">
                <img
                  src="@/assets/img/profiles/avatar-03.jpg"
                  class="rounded-circle"
                  alt="Img"
                />
              </a>
              <div>
                <router-link to="/provider/provider-reviews" class="fw-medium"
                  >Jerry Curran</router-link
                >
                <div class="d-flex align-items-center">
                  <p class="fs-12 mb-0 pe-2 border-end">
                    For <span class="text-info"> Makeup Artists</span>
                  </p>
                  <span class="avatar avatar-sm mx-2">
                    <img
                      src="@/assets/img/user/user-06.jpg"
                      class="img-fluid rounded-circle"
                      alt="user"
                    />
                  </span>
                  <span class="fs-12"> Pique </span>
                </div>
              </div>
            </div>
            <div class="d-flex">
              <span class="text-warning fs-10">
                <i class="ti ti-star-filled filled"></i>
                <i class="ti ti-star-filled filled"></i>
                <i class="ti ti-star-filled filled"></i>
                <i class="ti ti-star-filled filled"></i>
                <i class="ti ti-star-filled filled"></i>
              </span>
              <span class="fs-12">4.9</span>
            </div>
          </div>
        </div>
        <div class="border-bottom pb-3 mb-3">
          <div
            class="d-flex justify-content-between align-items-center flex-wrap row-gap-2"
          >
            <div class="d-flex">
              <a href="javascript:void(0);" class="avatar avatar-lg flex-shrink-0 me-2">
                <img
                  src="@/assets/img/profiles/avatar-02.jpg"
                  class="rounded-circle"
                  alt="Img"
                />
              </a>
              <div>
                <router-link to="/provider/provider-reviews" class="fw-medium"
                  >Livengood</router-link
                >
                <div class="d-flex align-items-center">
                  <p class="fs-12 mb-0 pe-2 border-end">
                    For <span class="text-info"> Plumbing Repairs</span>
                  </p>
                  <span class="avatar avatar-sm mx-2">
                    <img
                      src="@/assets/img/user/user-04.jpg"
                      class="img-fluid rounded-circle"
                      alt="user"
                    />
                  </span>
                  <span class="fs-12">Adrian</span>
                </div>
              </div>
            </div>
            <div class="d-flex">
              <span class="text-warning fs-10">
                <i class="ti ti-star-filled filled"></i>
                <i class="ti ti-star-filled filled"></i>
                <i class="ti ti-star-filled filled"></i>
                <i class="ti ti-star-filled filled"></i>
                <i class="ti ti-star-filled filled"></i>
              </span>
              <span class="fs-12">4.9</span>
            </div>
          </div>
        </div>
        <div class="">
          <div
            class="d-flex justify-content-between align-items-center flex-wrap row-gap-2"
          >
            <div class="d-flex">
              <a href="javascript:void(0);" class="avatar avatar-lg flex-shrink-0 me-2">
                <img
                  src="@/assets/img/profiles/avatar-03.jpg"
                  class="rounded-circle"
                  alt="Img"
                />
              </a>
              <div>
                <router-link to="/provider/provider-reviews" class="fw-medium"
                  >Karl Brown</router-link
                >
                <div class="d-flex align-items-center">
                  <p class="fs-12 mb-0 pe-2 border-end">
                    For <span class="text-info"> Construction Worker</span>
                  </p>
                  <span class="avatar avatar-sm mx-2">
                    <img
                      src="@/assets/img/user/user-05.jpg"
                      class="img-fluid rounded-circle"
                      alt="user"
                    />
                  </span>
                  <span class="fs-12">Andreson </span>
                </div>
              </div>
            </div>
            <div class="d-flex">
              <span class="text-warning fs-10">
                <i class="ti ti-star-filled filled"></i>
                <i class="ti ti-star-filled filled"></i>
                <i class="ti ti-star-filled filled"></i>
                <i class="ti ti-star-filled filled"></i>
                <i class="ti ti-star-filled filled"></i>
              </span>
              <span class="fs-12">4.9</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-6 d-flex">
    <div class="card flex-fill">
      <div class="card-body">
        <div
          class="d-flex justify-content-between align-items-center flex-wrap row-gap-2 mb-4"
        >
          <h6>Highly Rated Staffs</h6>
          <a
            href="javascript:void(0);"
            class="btn border"
            data-bs-toggle="modal"
            data-bs-target="#add-staff"
            >Add New Staff</a
          >
        </div>
        <div
          class="d-flex justify-content-between align-items-center border-bottom flex-wrap row-gap-2 pb-3 mb-3"
        >
          <div class="d-flex">
            <router-link to="/provider/staff-details" class="avatar avatar-lg me-2">
              <img
                src="@/assets/img/profiles/avatar-20.jpg"
                class="rounded-circle"
                alt="Img"
              />
            </router-link>
            <div>
              <router-link to="/provider/staff-details" class="fw-medium">Maude Rossi</router-link>
              <div class="fs-12 d-flex justify-content-between align-items-center gap-2">
                <span class="pe-2 border-end">Plumber</span>
                <span><i class="ti ti-star-filled text-warning"></i>4.9</span>
              </div>
            </div>
          </div>
          <span class="badge badge-info">
            <i class="ti ti-point-filled"></i>
            300 Bookings
          </span>
        </div>
        <div
          class="d-flex justify-content-between align-items-center border-bottom flex-wrap row-gap-2 pb-3 mb-3"
        >
          <div class="d-flex">
            <router-link to="/provider/staff-details" class="avatar avatar-lg me-2">
              <img
                src="@/assets/img/profiles/avatar-21.jpg"
                class="rounded-circle"
                alt="Img"
              />
            </router-link>
            <div>
              <router-link to="/provider/staff-details" class="fw-medium"
                >Floyd Andrian</router-link
              >
              <div class="fs-12 d-flex justify-content-between align-items-center gap-2">
                <span class="pe-2 border-end">Electrician</span>
                <span><i class="ti ti-star-filled text-warning"></i>4.9</span>
              </div>
            </div>
          </div>
          <span class="badge badge-info">
            <i class="ti ti-point-filled"></i>
            158 Bookings
          </span>
        </div>
        <div
          class="d-flex justify-content-between align-items-center border-bottom flex-wrap row-gap-2 pb-3 mb-3"
        >
          <div class="d-flex">
            <router-link to="/provider/staff-details" class="avatar avatar-lg me-2">
              <img
                src="@/assets/img/profiles/avatar-22.jpg"
                class="rounded-circle"
                alt="Img"
              />
            </router-link>
            <div>
              <router-link to="/provider/staff-details" class="fw-medium"
                >Michael Ruiz</router-link
              >
              <div class="fs-12 d-flex justify-content-between align-items-center gap-2">
                <span class="pe-2 border-end">Painter</span>
                <span><i class="ti ti-star-filled text-warning"></i>4.9</span>
              </div>
            </div>
          </div>
          <span class="badge badge-info">
            <i class="ti ti-point-filled"></i>
            157 Bookings
          </span>
        </div>
        <div
          class="d-flex justify-content-between align-items-center border-bottom flex-wrap row-gap-2 pb-3 mb-3"
        >
          <div class="d-flex">
            <router-link to="/provider/staff-details" class="avatar avatar-lg me-2">
              <img
                src="@/assets/img/profiles/avatar-23.jpg"
                class="rounded-circle"
                alt="Img"
              />
            </router-link>
            <div>
              <router-link to="/provider/staff-details" class="fw-medium">
                Glenn Lewis</router-link
              >
              <div class="fs-12 d-flex justify-content-between align-items-center gap-2">
                <span class="pe-2 border-end">Electrician</span>
                <span><i class="ti ti-star-filled text-warning"></i>4.9</span>
              </div>
            </div>
          </div>
          <span class="badge badge-info">
            <i class="ti ti-point-filled"></i>
            156 Bookings
          </span>
        </div>
        <div
          class="d-flex justify-content-between align-items-center border-bottom flex-wrap row-gap-2 pb-3 mb-3"
        >
          <div class="d-flex">
            <router-link to="/provider/staff-details" class="avatar avatar-lg me-2">
              <img
                src="@/assets/img/profiles/avatar-24.jpg"
                class="rounded-circle"
                alt="Img"
              />
            </router-link>
            <div>
              <router-link to="/provider/staff-details" class="fw-medium">
                Kimberly Meissner</router-link
              >
              <div class="fs-12 d-flex justify-content-between align-items-center gap-2">
                <span class="pe-2 border-end">Electrician</span>
                <span><i class="ti ti-star-filled text-warning"></i>4.9</span>
              </div>
            </div>
          </div>
          <span class="badge badge-info">
            <i class="ti ti-point-filled"></i>
            120 Bookings
          </span>
        </div>
        <div
          class="d-flex justify-content-between align-items-center flex-wrap row-gap-2"
        >
          <div class="d-flex">
            <router-link to="/provider/staff-details" class="avatar avatar-lg me-2">
              <img
                src="@/assets/img/profiles/avatar-25.jpg"
                class="rounded-circle"
                alt="Img"
              />
            </router-link>
            <div>
              <router-link to="/provider/staff-details" class="fw-medium">
                Lisa Jackson</router-link
              >
              <div class="fs-12 d-flex justify-content-between align-items-center gap-2">
                <span class="pe-2 border-end">Electrician</span>
                <span><i class="ti ti-star-filled text-warning"></i>4.9</span>
              </div>
            </div>
          </div>
          <span class="badge badge-info">
            <i class="ti ti-point-filled"></i>
            120 Bookings
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
